import { YARS } from './yarConfig.ts';
import './yarMark.css';

/**
 * The general «ساختار یار» character as a small mark: the sidebar entry, the chat speaker, the
 * assistant menu and the empty chat. One image, one place, so the assistant looks the same
 * everywhere it speaks. Decorative: the label next to it names the assistant.
 */
export function YarMark({
  size,
  className,
}: {
  readonly size: number;
  readonly className?: string;
}) {
  return (
    <img
      className={className ? `yar-mark ${className}` : 'yar-mark'}
      src={YARS.sakhtar.image}
      alt=""
      width={size}
      height={size}
      draggable={false}
      aria-hidden="true"
    />
  );
}
